var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grey darken-4 main-content",attrs:{"id":"ClientWelcomePage"}},[_c('LeftNav'),_vm._v(" "),_c('v-main',[_c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":"","justify-center":""}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }